// Grootste losse verkoop ooit en per verkoper zijn eigen grootste, bewaard over herstarts en maanden heen.

const storageKey = "td-sale-record";
const bestsKey = "td-seller-bests";

function load(key) {
  try {
    const raw = window.localStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    // Privémodus of volle opslag: dan zonder records.
    return null;
  }
}

function save(key, value) {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* mag het dashboard niet ophouden */
  }
}

function remove(key) {
  try {
    window.localStorage.removeItem(key);
  } catch {
    /* zie boven */
  }
}

export function readRecord() {
  const record = load(storageKey);
  return typeof record?.amount === "number" ? record : null;
}

export function writeRecord(record) {
  save(storageKey, record);
}

export function clearRecord() {
  remove(storageKey);
}

// { naam: { amount, at } }; een onbekende naam ontbreekt, zodat een eerste verkoop geen record-kaart geeft.
export function readBests() {
  const bests = load(bestsKey);
  return bests && typeof bests === "object" ? bests : {};
}

export function writeBests(bests) {
  save(bestsKey, bests);
}

export function clearBests() {
  remove(bestsKey);
}
